import Image from "next/image";
import { useEffect, useState } from "react";
const IMG_ALT_TEXT = "Social Networking App through NFC technology";
const IMG_SRC = "/assets/case-study/social-networking/linx-2.gif";
const LinxVideo = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isTab, setIsTab] = useState(false);
  useEffect(() => {
    if (window.innerWidth < 768) {
      setIsMobile(true);
    } else if (window.innerWidth < 1080) {
      setIsTab(true);
    } else {
      setIsMobile(false);
      setIsTab(false);
    }
  }, []);

  const ResponsiveComponent = () => {
    if (isMobile) {
      return (
        <div className="relative bottom-36 right-32">
          <Image
            alt={IMG_ALT_TEXT}
            className="!w-[170%] h-auto"
            src={IMG_SRC}
            width={722}
            height={406}
            layout="fixed"
          />
        </div>
      );
    } else if (isTab) {
      return (
        <div className="relative right-48 bottom-40">
          <Image
            alt={IMG_ALT_TEXT}
            className="w-[140%]"
            src={IMG_SRC}
            width={1075}
            height={604}
            layout="fixed"
          />
        </div>
      );
    }
    return (
      <div>
        <Image
          alt={IMG_ALT_TEXT}
          src={IMG_SRC}
          width={1920}
          height={1080}
          layout="fixed"
        />
      </div>
    );
  };

  return (
    <div className="bg-light-pink rounded-b-[50%] h-[34vh] md:h-[48vh] xl:h-auto">
      {ResponsiveComponent()}
    </div>
  );
};
export default LinxVideo;
